import React from 'react';
import isEqual from 'react-fast-compare';

import HRTemplateActions from 'molbio/crispr/hr-template/HRTemplateActions';
import HRTemplateStore from 'molbio/crispr/hr-template/HRTemplateStore';
import Modal from 'ui-library/modals/Modal';

import SettingsForm from './SettingsForm';

interface HRTemplateSettings {
  pam: string;
  genome: string;
}

interface SettingsModalProps {
  sequenceId: string;
  onRequestClose: () => void;
}

interface SettingsModalState {
  settings: HRTemplateSettings;
}

export default class SettingsModal extends React.Component<SettingsModalProps, SettingsModalState> {
  oldSettings: HRTemplateSettings;

  constructor(props: SettingsModalProps) {
    super(props);
    const {pam, genome} = HRTemplateStore.getDesignState(props.sequenceId)!;
    const settings = {
      pam,
      genome: genome.ensemblName,
    };

    this.oldSettings = settings;
    this.state = {settings};
  }

  save = (): void => {
    const newSettings = this.state.settings;
    const changedSettings: HRTemplateSettings = {} as HRTemplateSettings;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in newSettings) {
      const newValue = newSettings[key as keyof HRTemplateSettings];
      if (!isEqual(this.oldSettings[key as keyof HRTemplateSettings], newValue)) {
        changedSettings[key as keyof HRTemplateSettings] = newValue;
      }
    }
    HRTemplateActions.serverUpdate(this.props.sequenceId, changedSettings);
    this.props.onRequestClose();
  };

  handleChangeSettings = (value: {pam: string; genome: string}): void => {
    this.setState({settings: value});
  };

  override render(): JSX.Element {
    return (
      <Modal
        title="HR template design settings"
        onRequestSubmit={this.save}
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            text: 'Save',
            submit: true,
          },
        ]}
      >
        <SettingsForm settings={this.state.settings} onChange={this.handleChangeSettings} />
      </Modal>
    );
  }
}
